"use client";
import { useEffect, useState } from "react";
import BupiLinkButton from "@/components/atoms/linkButton";
import Heading from "@/components/molecules/Heading";
import { ImageBannerBlockProps } from "@/page-builder/fragments/ImageBannerBlock/types";
import { RichText as RichTextConverter } from "@payloadcms/richtext-lexical/react";
import Image from "@/components/atoms/image";
import { useMediaQuery } from "@/hooks/useMediaQuery";

export default function ImageBannerBlockContent({
  title,
  description,
  backgroundImage,
  cta,
  backgroundStyle,
  titleEffectStyle,
}: ImageBannerBlockProps) {
  const bottomfull = backgroundStyle === "flat_Bottom";
  const [clipPath, setClipPath] = useState<string>("");
  const { isDesktop } = useMediaQuery();
  const updateClipPath = () => {

    if (!bottomfull) {
      if (isDesktop) {
        setClipPath(
          "polygon(50% 9%, 100% 0, 100% 35%, 100% 70%, 100% 93%, 50% 100%, 19% 88%, 0 100%, 0 14%, 22% 0)"
        );
      } else {
        setClipPath(
          "polygon(100% 4%, 100% 95%, 85% 99%, 25% 90%, 0 100%, 0 5%, 51% 0)"
        );
      }
    } else {
      if (isDesktop) {
        setClipPath(
          "polygon(21% 0, 49% 12%, 100% 0, 100% 100%, 70% 100%, 30% 100%, 0 100%, 0 16%)"
        );
      } else {
        setClipPath(
          "polygon(47% 0, 100% 8%, 100% 100%, 49% 100%, 18% 100%, 0 100%, 0 9%)"
        );
      }
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      updateClipPath();
      window.addEventListener("resize", updateClipPath);
      return () => window.removeEventListener("resize", updateClipPath);
    }
  }, [bottomfull, isDesktop]);

  return (
    <div
      className="relative w-full"
    >
      <div
        className="w-full bg-cover bg-center relative z-10"
        style={{ clipPath }}
      >
        {backgroundImage?.url && (
          <Image
            src={backgroundImage.url}
            alt={""}
            fill
            className="object-cover"
            loading="lazy"
            title={backgroundImage.alt || "Banner background"}
            priority={false}
          />
        )}

        <div className="container mx-auto px-4 py-[150px] xl:py-[200px] relative z-20">
          <div className="max-w-5xl mx-auto text-center">
            <Heading title={title} titleEffectStyle={titleEffectStyle} />
            <RichTextConverter
              className={`text-m-regular ${
                titleEffectStyle !== "secondary"
                  ? "text-neutral-900"
                  : "text-white"
              } pt-8 pb-24`}
              data={description as any}
            />
            <div className="flex justify-center  items-center">
              {cta?.url && (
                <BupiLinkButton
                className="w-full md:w-auto"
                  link={cta?.url}
                  label={cta?.label}
                  target={cta?.target || "_self"}
                  hasIcon
                  leadingIcon="agora-line-arrow-right-circle"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
